// extracted by mini-css-extract-plugin
export default {"divider":"Burn_divider__5d1sB","buttonsWrapper":"Burn_buttonsWrapper__dP9Vv"};